import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditUserInvitationPayload } from '@app-store/slices/eventSettings/editUserInvitation'

interface TaskAction extends Action {
    payload: IEditUserInvitationPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.eventSetting.editUserInvitation

function* editUserInvitationSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.patch(`/event/settings/${payload.settingId}/user-invitation`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editUserInvitationSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editUserInvitationSagaTask)
}

export default editUserInvitationSaga
